/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import React from 'react';
import { compose } from 'redux';
import Page from '../../Components/Page/Page.component';
import Terms from '../../Components/Terms/Terms.component';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import OrdersPageSidebar from '../Orders/Orders.page.sidebar';
import './Terms.page.i18n';
import TermsPagePropTypes from './Terms.page.props';
import termsPageStyles from './Terms.page.styles';

/**
 * TermsPage
 * @export
 * @class TermsPage
 * @extends {React.Component<TermsComponentComposedProps, TermsComponentState>}
 */
export class TermsPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<TermsPageComponentProps>}
   * @memberof TermsPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`TermsPage`}
   * @memberof TermsPageComponent
   */
  static displayName = `TermsPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof TermsPageComponentProps
   */
  static propTypes = TermsPagePropTypes;

  /**
   * Data specific to the `<TermsPage />` instance
   * @type {TermsPageComponentState}
   * @memberof TermsPageComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<TermsPagePage />`
   * @memberof TermsPageComponent
   */
  render() {
    const { classes, entry, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    const padding = isSmall ? `none` : `dense`;
    return (
      <Page
        heading="TermsPage.PageTitle"
        headingData={{ name: entry.name }}
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        hideUserMenu
        padding={padding}
        sidebarContent={<OrdersPageSidebar />}
        title="TermsPage.PageTitle"
      >
        <div className={classes.root}>
          <Terms />
        </div>
      </Page>
    );
  }
}

/** @type {React.ComponentClass<TermsPageComponentProps>} */
const TermsPage = compose(
  withEntries,
  withWidth(),
  withStyles(themeCreateInjectableStyles(termsPageStyles), { withTheme: true }),
)(TermsPageComponent);

export default TermsPage;
